<template>
  <div id="app">
    <div class="logobox">
      <div class="box">
        <div class="logo"></div>
      </div>
    </div>
    <div class="inputBox">
      <div class="inputOne">
        <div class="icon">用户名</div>
        <input
          v-model="username"
          type="text"
          class="input"
          placeholder="请输入用户名"
        />
      </div>
      <div class="inputOne">
        <div class="icon">密&nbsp;&nbsp;&nbsp;&nbsp;码</div>
        <input
          class="input"
          v-model="password"
          type="password"
          placeholder="请输入密码"
        />
      </div>
    </div>
    <div class="loginBtn">
      <button
        class="button"
        @click="login"
      >
        登 录
      </button>
    </div>
    <div class="loading" v-if="isLoading">
      <div class="bounce">
        <van-icon color="#fff" size="2rem" name="replay" />
      </div>
      <div style="font-size: .9rem;">登录中...</div>
    </div>
  </div>
</template>

<script>
import stringfy from "@/utils/stringfy";
import { Toast } from "mint-ui";
import request from "@/utils/keyCloakRequest";
export default {
  data() {
    return {
      username: "",
      password: "",
      isLoading: false,
      hidshow: true,
      userInfo: {},
    };
  },
  async created() {
    this.username = localStorage.getItem('username')
    this.password = localStorage.getItem('password')
  },
  methods: {
    containsChinese(str) {
      // 正则表达式 [\u4e00-\u9fa5] 匹配所有中文字符
      const chineseRegex = /[\u4e00-\u9fa5]/;
      return chineseRegex.test(str);
    },
    async login() {
        if (!this.username) {
          Toast({
            message: "请输入用户名",
            position: "top",
            duration: 3000
          });
          return false;
        }
        if (!this.password) {
          Toast({
            message: "请输入密码",
            position: "top",
            duration: 3000
          });
          return false;
        }
        if (this.username && this.password) {
          localStorage.setItem('username',this.username)
          localStorage.setItem('password',this.password)
          const data = stringfy({
            username: this.username,
            password: this.password,
          });
          this.isLoading = true;
          await request({
            url: "applogins",
            method: "POST",
            data: data
          }).then(async response => {
              if(this.containsChinese(response)){
                Toast({
                  message: response,
                  position: "top",
                  duration: 3000
                });
                this.isLoading = false
              }else {
              await  request({
                  url: "appfindByUserId?userid="+response,
                  method: "get"
                }).then( async response => {
                 await this.$store.dispatch(
                      "user/setUserInfo",
                      JSON.stringify(response)
                  );
                this.$router.push("/home");
                })
                this.isLoading = false
              }
          })
        }
    },
  }
};
</script>
<style scoped>
.bounce {
  width: 3rem;
  height: 3rem;
  top: 50%;
  left: 50%;
  animation: animat 2s cubic-bezier(1, 0.5, 0.5, 1) infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes animat {
  0% {
    transform: rotate(20deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
#app {
  background: url("../../assets/images/shouye.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.loading {
  position: absolute;
  width: 5rem;
  height: 5rem;
  top: 50%;
  left: 50%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.logobox {
  height: 17.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logobox .box {
  height: 80%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logobox .box .logo {
  background: url("../../assets/images/1733904898627.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 10rem;
  width: 10rem;
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.5); /* 添加内阴影 */
}
.logobox .box .text {
  width: 100%;
  font-size: 1.25rem;
  line-height: 1.25rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inputBox {
  height: 7.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.inputBox .inputOne {
  width: 90%;
  border-radius: .4rem;
  align-items: center;
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
}
.inputBox .inputOne:last-child {
  margin-top: .6rem;
}
.inputBox .inputOne .input {
  height: 3rem !important;
  color: #f5f5f5bf;
  background: rgba(255, 255, 255, 0);
  border: none;
  outline: none;
  flex: 1;
  font-size: 1rem;
}
.inputBox .inputOne .input::placeholder {
  color: rgba(255, 255, 255, 0.7); /* 例如，将placeholder的字体颜色设置为红色 */
  /* 你可以在这里添加更多的样式，比如字体大小、字体家族等 */
  font-size: 1rem; /* 示例：设置placeholder的字体大小 */
}
.inputBox .inputOne .icon {
  width: 4.5rem;
  display: flex;
  justify-content: flex-start;
  color: #fff;
  /* background: rgba(255, 255, 255, 0.1); */
  padding: 0 0.5rem;
  font-size: 1rem;
}
.inputBox .inputOne .thisimage {
  color: #f5f5f5bf;
  background: rgba(255, 255, 255, 0);
  border: none;
  outline: none;
  flex: 1;
  font-size: 1rem;
}
.loginBtn {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.loginBtn .button {
  width: 90%;
  margin-top: 3rem;
  background: #2c76cf;
  height: 3rem;
  border-radius: .4rem;
  font-size: 1.2rem;
  color: #fff;
  border: none;
}
.opacity6 {
  opacity: 0.6;
}
.opacity {
  opacity: 1;
}
</style>
